var map = {
	"./active-btn.webp": 2534,
	"./angbao-bonus-cny.webp": 2535,
	"./angbao-bonus-dewali.webp": 2536,
	"./angbao-bonus-mooncake.webp": 2537,
	"./angbao-bonus-raya.webp": 2538,
	"./angbao-bonus-thaipusam.webp": 2539,
	"./angbao-bonus.webp": 2540,
	"./anni-lucky-draw.webp": 2541,
	"./cny-angbao-bonus.webp": 2542,
	"./cny-lucky-draw.webp": 2543,
	"./cny-promo.webp": 2544,
	"./dewali-promo.webp": 2545,
	"./dongzhi-angbao-bonus.webp": 2546,
	"./fifa-prediction.webp": 2547,
	"./fifa-qna.webp": 2548,
	"./uefa-predic.webp": 2549,
	"./welcome-cny-bonus.webp": 2550
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2533;